import { useMemo } from 'react'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import LearningPage from './LearningPage'
import { questions, getQuestionById } from '../data/questions'

/**
 * URL パラメータから問題を取得して LearningPage に渡すラッパー
 */
export default function LearnWrapper() {
  const { questionId } = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const qId = parseInt(questionId, 10)
  const question = getQuestionById(qId)

  const learningMode = useMemo(() => {
    const modeParam = searchParams.get('mode')
    if (modeParam === 'guided' || modeParam === 'free') return modeParam
    const saved = localStorage.getItem('chemcraftLearningMode')
    return saved === 'free' ? 'free' : 'guided'
  }, [searchParams])
  const modeQuery = `mode=${learningMode}`

  if (!question) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#0a0e1a' }}>
        <div className="text-center">
          <p className="text-white/50 text-lg mb-4">問題が見つかりません</p>
          <button onClick={() => navigate('/questions')}
            className="px-6 py-3 rounded-lg font-bold text-white"
            style={{ background: 'linear-gradient(135deg, #34D399, #14B8A6)' }}>
            問題一覧に戻る
          </button>
        </div>
      </div>
    )
  }

  const currentIndex = questions.findIndex((q) => q.id === qId)

  const goNext = () => {
    if (currentIndex < questions.length - 1) {
      navigate(`/learn/${questions[currentIndex + 1].id}?${modeQuery}`)
    }
  }
  const goPrev = () => {
    if (currentIndex > 0) {
      navigate(`/learn/${questions[currentIndex - 1].id}?${modeQuery}`)
    }
  }
  const handleLearningModeChange = (mode) => {
    localStorage.setItem('chemcraftLearningMode', mode)
    navigate(`/learn/${qId}?mode=${mode}`, { replace: true })
  }

  return (
    <LearningPage
      key={qId}
      question={question}
      onBack={() => navigate('/questions')}
      onNext={goNext}
      onPrev={goPrev}
      currentIndex={currentIndex}
      totalQuestions={questions.length}
      learningMode={learningMode}
      onLearningModeChange={handleLearningModeChange}
    />
  )
}
